import { render } from "./FlexColumn.vue?vue&type=template&id=6a43b246"
import script from "./FlexColumn.vue?vue&type=script&lang=js"
export * from "./FlexColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__